import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNote = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1536 1024",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1450.667 426.667h-1365.333c-46.933 0-85.333 38.4-85.333 85.333s38.4 85.333 85.333 85.333h1365.333c46.933 0 85.333-38.4 85.333-85.333s-38.4-85.333-85.333-85.333zM85.333 1024h853.333c46.933 0 85.333-38.4 85.333-85.333s-38.4-85.333-85.333-85.333h-853.333c-46.933 0-85.333 38.4-85.333 85.333s38.4 85.333 85.333 85.333zM1450.667 0h-1365.333c-46.933 0-85.333 38.4-85.333 85.333v0.853c0 46.933 38.4 85.333 85.333 85.333h1365.333c46.933 0 85.333-38.4 85.333-85.333v-0.853c0-46.933-38.4-85.333-85.333-85.333z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgNote);
export default ForwardRef;
